// src/data/m1/index.js

import { M1_UNIT_1 } from './Unit1';
import { M1_UNIT_2 } from './Unit2';
import { M1_UNIT_3 } from './Unit3';
import { M1_UNIT_4 } from './Unit4';
import { M1_UNIT_5 } from './Unit5';
import { M1_UNIT_6 } from './Unit6';
import { M1_UNIT_7 } from './Unit7';
import { M1_UNIT_8 } from './Unit8';
import { M1_UNIT_9 } from './Unit9';
import { M1_UNIT_10 } from './Unit10';
import { M1_UNIT_11 } from './Unit11';
import { M1_UNIT_12 } from './Unit12';
import { M1_UNIT_13 } from './Unit13';
import { M1_UNIT_14 } from './Unit14';
import { M1_UNIT_15 } from './Unit15';
import { M1_UNIT_16 } from './Unit16';
import { M1_UNIT_REVIEW } from './UnitReview';
import { M1_READING } from './ReadingPractice';

export const MODULE_1_UNITS = [
  M1_UNIT_1,
  M1_UNIT_2,
  M1_UNIT_3,
  M1_UNIT_4,
  M1_UNIT_5,
  M1_UNIT_6,
  M1_UNIT_7,
  M1_UNIT_8,
  M1_UNIT_9,
  M1_UNIT_10,
  M1_UNIT_11,
  M1_UNIT_12,
  M1_UNIT_13,
  M1_UNIT_14,
  M1_UNIT_15,
  M1_UNIT_16,
  M1_UNIT_REVIEW, // El examen final
  M1_READING      // La práctica de lectura
];